var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisableBagCreate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 49,
    viewBox: "0 0 40 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3649 0C9.95357 0 9.97869 1.82107 10.2927 2.73161C10.2927 6.65006 13.8721 10.0159 15.6619 11.209C2.92692 18.5938 -0.0684673 30.6757 0.0257113 35.7935C-0.577127 44.3086 9.57065 47.4421 14.7199 47.9445C26.0231 49.9791 34.061 46.0292 36.667 43.8C42.9214 38.7512 38.959 28.6348 36.196 24.2077C32.9558 16.6722 25.4894 11.8998 22.1612 10.4555C24.5725 9.32516 26.6197 4.3329 27.3418 1.97806C27.7186 -0.357935 25.8033 0 24.7986 0.470967L19.147 1.97806L18.3935 2.16645L17.2631 1.97806L12.3649 0Z",
    fill: "#DBDBDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.204 31.0441H27.378V33.8261H22.204V39.0001H19.422V33.8261H14.248V31.0441H19.422V25.8701H22.204V31.0441Z",
    fill: "#B7B7B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisableBagCreate);
export default __webpack_public_path__ + "static/media/disable-bag-create.a8cefcdc17cfa23e86770df2c0192a02.svg";
export { ForwardRef as ReactComponent };